import { Component, OnInit } from "@angular/core";
import { Education } from "src/app/model/education.dataContract";

@Component({
  selector: "app-education",
  templateUrl: "./education.component.html",
  styleUrls: ["./education.component.css"],
})
export class EducationComponent implements OnInit {
  educationList: Array<Education>;

  constructor() {}

  ngOnInit(): void {
    this.educationList = new Array<Education>();
    this.educationList = [
      {
        Major: "Software Development",
        grades: "",
        university: "UNIVERSITY OF TECHNOLOGY SYDNEY – SYDNEY, AUSTRALIA",
        course: "Master of Information Technology",
        duration: "August 2021 - July 2023",
      },
      {
        Major: "Computer Science",
        grades: "CGPA: 7.39",
        university:
          "SANGHVI INSTITUTE OF MANAGEMENT AND SCIENCE – INDORE, INDIA",
        course: "Bachelor of Engineering",
        duration: "August 2013 - June 2017",
      },

      // {
      //   course: `12th Grade`,
      //   grades: "Percentage: 56.4%",
      //   university: "New South Wales Higher Secondary School",
      //   Major: "",
      //   duration:""
      // },
      // {
      //   course: "10th Grade",
      //   grades: "CGPA: 5.8",
      //   university: "I.L.V.A Higher Secondary School",
      //   Major: "",
      //   duration:""
      // },
    ];
  }
}
